const Dsa = [
    {
      id: 1,
      name: "Rohit Khairnar",
      position: "DSA Lead",
      image: "https://i.ibb.co/wNfQrn0/rohit.png",
      alt: "Lead_Image",
      col: 3,
      linkedin: "https://www.linkedin.com/in/rohitkhairnar1/",
      instagram: "",
      github: "",
      link: "",
    },
  ];
  
  export default Dsa;
  